import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { api, paramsSerializer, paramsToQuery } from "../../urls";
import { IPlace } from "../types/places";

interface IState {
  items: IPlace[];
}

export const loadStreamsPlaces = createAsyncThunk<any, any>('streamsPlacesSlice/loadStreamsPlaces',
  async (params) => {
    const response = await axios.get(
      api.streams.getStreamsPlaces(),
      { params: paramsToQuery({ ...params }), paramsSerializer }
    );

    if (!response?.data?.places?.length) {
      return null;
    }

    return response?.data?.places;
  });

export const streamsPlacesSlice = createSlice<IState, any>({
  name: 'streamsPlaces',
  initialState: {
    items: [],
  },
  reducers: {
  },
  extraReducers: (builder) => {
    builder.addCase(loadStreamsPlaces.fulfilled, (state, { payload }) => {
      if (payload) {
        state.items = payload;
      }
    });
  }
});
